<template>
  <div class="global-msg-notify-wrapper" v-html="content"></div>
</template>

<script>
export default {
  name: 'GlobalMsgNotify',
  props: {
    content: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.global-msg-notify-wrapper {
  padding: 10px 20px;
  box-sizing: border-box;
  height: 40px;
  text-align: center;
  line-height: 20px;
  font-size: 14px;
  font-family: DiDiSansPro-Bold;
  font-weight: 700;
  color: #ffffff;
  background: #1bb17c;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: break-all;
  word-wrap: break-word;
}
</style>
